import React, {Component} from "react"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import downloadCsv from "@irati/utils/downloadCsv"
import Icon from "@irati/ui/src/Icon"
import {perkbox} from "@irati/ui/src/global/colors"
import Flex from "@irati/ui/src/Flex"

import {DownloadCsvText} from "../AddUsers/AddPeopleCSV/styled"

interface Props extends InjectIntl {}

class DownloadCsvTemplate extends Component<Props> {
  downloadCsv = () => {
    const {formatMessage} = this.props
    const headers: string = [
      formatMessage({id: "admin.components.addPeopleCSV.fieldsMapping.email.label"}),
      formatMessage({id: "admin.components.addPeopleCSV.fieldsMapping.team.label"})
    ].join(",")
    // \ufeff needed to specify the csv may contain utf-8 characters
    const csv = `\ufeff${headers}\n${formatMessage({id: "admin.components.assignManagersCSV.downloadCsvTemplate.csv"})}`
    const fileName = formatMessage({id: "admin.components.assignManagersCSV.downloadCsvTemplate.fileName"})
    downloadCsv(csv, fileName)
  }

  render() {
    return (
      <DownloadCsvText onClick={this.downloadCsv}>
        <Flex alignItems="center">
          <Icon icon="fileDownload" color={perkbox.blue} margin="0 5px 0 0" />
          <FormattedMessage id="admin.components.addPeopleCSV.downloadCsvTemplate.text" />
        </Flex>
      </DownloadCsvText>
    )
  }
}

export default injectIntl(DownloadCsvTemplate)
